import fadeInStyles from '../../styles/fade-in.module.scss'
import React, { useState } from 'react'
import { ImageProps } from 'react-bootstrap'

export const ImageUrl = (props: { url: string; alt?: string; className?: string } & ImageProps): React.ReactElement => {
  const { alt, url, className, ...imageProps } = props
  const [isLoaded, setIsLoaded] = useState(false)

  const handleImageLoad = (event: React.SyntheticEvent<HTMLImageElement>): void => {
    setIsLoaded(true)
    if (imageProps.onLoad) {
      imageProps.onLoad(event)
    }
  }

  const fadeInClassName = `${fadeInStyles.fadeIn} ${isLoaded ? fadeInStyles.loaded : ''} ${className || ''}`.trim()

  return <img src={url} alt={alt ?? ''} className={fadeInClassName} onLoad={handleImageLoad} {...imageProps} />
}
